import React, { useState, useEffect } from "react";
import {
 usePostAddressSellandBuyMutation
} from "./ProcurementApiSlice";
import { TextField } from "@mui/material";

import {Col } from "react-bootstrap";

import { Button as AntButton ,ConfigProvider} from 'antd';

const BuyerAddressAdd = ({ handleChange, addStockData,UserData,refetchAddress,setIsModalOpen,handleClose }) => {
 

 
  const [postAddressSeller, createpostAddressSeller,] = usePostAddressSellandBuyMutation();
  const [PincodeDataList, setPincodeDataList] = useState({
    State: "",
    District: "",
    Block: "",
  });
  const [pincodeError, setPinCodeError] = useState(false);
  const [PincodeValue, setPincode] = useState("");
 
  
  
 
  const handleChangePin = (name) => (e, value) => {
    setPincodeDataList({
      ...PincodeDataList,
      [e.target.name]: e.target.value,
    });
  };
  

  const handlePinCodeChange = (e) => {
    const newPinCode = e.target.value;
    if (newPinCode.length <= 6) {
      setPincode(newPinCode);
    }
  };
  useEffect(() => {
    const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data[0].Status === "Success") {
          setPincodeDataList(data[0].PostOffice[0]);
          setPinCodeError(false);
        }
        if (data[0].Status === "Error") {
          setPinCodeError(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [PincodeValue]);

  
 
  
  
  const postAddress=()=>{
 
    let data ={
      "address_line1": addStockData.address,
      "address_line2": PincodeDataList?.Block,
      city:PincodeDataList?.District,
      state: PincodeDataList?.State,
      "country": "India",
      "pincode": PincodeValue,
      "email_id": "",
      "phone": "",
      "fax": "",
      "gstin": "",
      "gst_state": "",
      "links": [
          {
              "link_doctype": "Customer",
              "link_name": UserData
          }
      ]
  }
  postAddressSeller(data)
  .unwrap()
  .then((data) => {
    refetchAddress()
    setPincode("")
    setPincodeDataList({       
     State:"",
     District:"",
     Block:""
   }) 
   setIsModalOpen(false)
   
  })
  .catch((error) => {
    return
  })
  }


  return (
    <>
     

         
        
        <div className="row">
        <Col lg="4" className="MuiTextArea2 mt-2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Pincode"
                  name="pincode"
                  value={PincodeValue}
                  onChange={handlePinCodeChange}
                  maxLength="6"
                  required
                  className="mt-1"
                  maxRows={2}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                />

                {PincodeValue.length > 6 ||
                  (pincodeError && (
                    <div style={{ color: "red" }}>Enter a valid pincode</div>
                  ))}
              </Col>
              <div className="col-lg-8 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="State"
                  name="State"
                  onChange={handleChangePin("StateName")}
                  value={PincodeDataList?.State}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                />
              </div>
              <div className="col-lg-6 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="District"
                  name="District"
                  onChange={handleChangePin("DistrictName")}
                  value={PincodeDataList?.District}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                />
              </div>{" "}
              <div className="col-lg-6 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Block"
                  name="Block"
                  onChange={handleChangePin("BlockName")}
                  value={PincodeDataList?.Block}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                />
              </div>
              <div className="col-lg-12 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Address"
                  name="address"
                  onChange={handleChange("address")}
                //   value={addStockData.address}
                  required
                  className="mt-3"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                />
              </div>
             <div>
              <AntButton type="primary" danger  className="mt-2 float-end mx-3" onClick={handleClose}>
             Cancel
           </AntButton>
            <AntButton type="primary" className="mt-2 float-end" onClick={postAddress} >
          Submit
        </AntButton>
        </div>
         

        </div>
       
        

        
     
    </>
  );
};

export default BuyerAddressAdd;
